import { render } from "./ProfileViewer.vue?vue&type=template&id=b5306f1c&scoped=true"
import script from "./ProfileViewer.vue?vue&type=script&lang=js"
export * from "./ProfileViewer.vue?vue&type=script&lang=js"

import "./ProfileViewer.vue?vue&type=style&index=0&id=b5306f1c&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5306f1c"]])

export default __exports__